<div mat-dialog-title>
  <h2>Jump To</h2>
  <button mat-icon-button title="Close Dialog" class="mat-dialog-title__close" (click)="onClose()">
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
</div>
<mat-dialog-content id="jumpToPositionContainer" class="jump-to-position__content">
  <div class="jump-to-position__question-to-move">
    <span class="jump-to-position__question-to-move__header fs__md fw__600">Choose where to move this question:</span>
    <div class="jump-to-position__question-to-move__q-title">
      <fa-icon [icon]="questionTypeConfig[questionToMove.type].icon"></fa-icon>
      <span>{{ questionToMove.code }}. {{ questionToMove.title | toPlainText }}</span>
    </div>

    @for (warning of warnings$(); track warning) {
      <div class="jump-to-position__warning" [class.blocker]="warning.blockerInd">
        <fa-icon [icon]="warning.blockerInd ? faExclamationTriangle : faCircleExclamation"></fa-icon>
        <span class="jump-to-position__warning__text fs__sm" [innerHTML]="warning.message"></span>
      </div>
    }
  </div>

  <div class="jump-to-position__question-list" [style.height.px]="430 - warnings$().length * 56">
    @for (questionData of questionsWithBlocks; track questionData.question.id) {
      @if (
        ($index !== questionToMoveIndex && $index !== nextQuestionIndex && !questionData.isInsideMultiBlock) ||
        (questionData.isInsideMultiBlock &&
          (questionData.isFirstBlockInsideMultiBlock || !questionData.isFirstElementInBlock) &&
          $index !== questionToMoveIndex &&
          $index !== nextQuestionIndex) ||
        (!questionData.isInsideMultiBlock && !!questionData.block)
      ) {
        <button
          mat-stroked-button
          class="jump-to-position__question-list__position"
          [class.selected]="selectedPosition$() === $index && !isBlockBeginning$() && !isBlockEnd$()"
          (click)="onPickedPosition($index, !!questionData.block && !questionData.isFirstElementInBlock, questionData.block)"
        >
          @if ($index === 0) {
            <span>+ Move to the beginning</span>
          } @else if ($index > 0) {
            <span
              >+ Insert before {{ questionData.question.code
              }}{{ questionData.block && questionData.isFirstElementInBlock ? ', outside of block ' + questionData.block.id : '' }}
            </span>
          }
        </button>
      }

      @if (questionData.isFirstElementInBlock && questionData.question.id !== questionToMove.id) {
        <button
          mat-stroked-button
          class="jump-to-position__question-list__position"
          [class.selected]="selectedPosition$() === $index && moveIntoBlock$() && isBlockBeginning$()"
          (click)="onPickedPosition($index, true, questionData.block, true, false)"
        >
          <span>Move to the beginning of block {{ questionData.block.id }}</span>
        </button>
      }

      <div class="jump-to-position__question-list__q-title" [class.moving]="questionData.question.id === data.questionToMoveId">
        <fa-icon [icon]="questionTypeConfig[questionData.question.type].icon"></fa-icon>
        <span>{{ questionData.question.code }}. {{ questionData.question.title | toPlainText }}</span>
      </div>

      @if (questionData.isLastElementInBlock && questionData.question.id !== questionToMove.id) {
        <button
          mat-stroked-button
          class="jump-to-position__question-list__position"
          [class.selected]="selectedPosition$() === $index && moveIntoBlock$() && isBlockEnd$()"
          (click)="onPickedPosition($index, true, questionData.block, false, true)"
        >
          <span>Move to the end of block {{ questionData.block.id }}</span>
        </button>
      }

      @if (($index !== questionToMoveIndex || questionData.isLastElementInBlock) && $index === surveyEditorService.surveyEditor$().questions.length - 1) {
        <button
          mat-stroked-button
          class="jump-to-position__question-list__position"
          [class.selected]="selectedPosition$() === $index + 1"
          (click)="onPickedPosition($index + 1)"
        >
          + Move to the end
        </button>
      }
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="jump-to-position__actions" [class.positioned]="selectedPosition$() !== null">
  @if (selectedPosition$() !== null) {
    @if (selectedPosition$() === 0) {
      <span class="fs__md fw__500"> Moving to the beginning </span>
    } @else if (selectedPosition$() === surveyEditorService.surveyEditor$().questions.length) {
      <span class="fs__md fw__500"> Moving to the end </span>
    } @else {
      <span class="fs__md fw__500">
        Moving before: <strong>{{ selectedQuestion$().code }}</strong>
      </span>
    }
  }
  <div>
    <button mat-stroked-button (click)="onClose()">Cancel</button>
    <button mat-flat-button [color]="'primary'" [disabled]="selectedPosition$() === null || anyBlocker$()" (click)="onMove()">Confirm</button>
  </div>
</mat-dialog-actions>
